export const AssociateTypes = {
    customer: 'Customer',
    broker: 'Broker',
    driver: 'Driver',
};
